var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSpin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 52,
    viewBox: "0 0 58 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.879 50.1152C38.879 49.5497 38.7965 48.706 38.3419 47.8218C37.4943 46.1762 36.1185 45.877 35.0969 44.3735C34.6513 43.7183 34.1697 42.6815 34.1697 41.0928H24.1467C24.1467 42.683 23.6651 43.7183 23.2196 44.3735C22.1964 45.8785 20.8222 46.1777 19.9746 47.8218C19.5185 48.706 19.4375 49.5497 19.4375 50.1152C22.561 50.193 35.757 50.193 38.8805 50.1152H38.879Z",
    fill: "#F3B91A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.8077 51.9999H18.5044V50.3917C18.5044 50.1299 18.7174 49.9175 18.98 49.9175H39.3306C39.5931 49.9175 39.8062 50.1299 39.8062 50.3917V51.9999H39.8077Z",
    fill: "#F3B91A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    style: {
      mixBlendMode: "overlay"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.5571 49.9176C22.0512 49.8727 25.5467 49.8847 29.0422 49.8667C32.5378 49.8847 36.0318 49.8742 39.5273 49.9176C36.0318 49.9624 32.5378 49.9505 29.0422 49.9684C25.5482 49.9505 22.0527 49.9609 18.5571 49.9176Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M36.4382 45.8242H22.0195C21.3204 46.3942 20.6213 46.8939 20.1127 47.8812C19.6596 48.7594 19.5786 49.5972 19.5786 50.1582C22.6796 50.236 35.7781 50.236 38.8776 50.1582C38.8776 49.5972 38.7966 48.7594 38.3435 47.8812C37.8349 46.8939 37.1343 46.3957 36.4367 45.8242H36.4382Z",
    fill: "url(#paint0_linear_4109_656)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M44.151 38.5326C48.3081 34.3991 50.3874 28.9806 50.3874 23.562H29.0962L44.151 38.5326Z",
    fill: "#8FC275"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M50.3874 23.5619C50.3874 18.1434 48.3081 12.7248 44.151 8.59131L29.0962 23.5619H50.3874Z",
    fill: "#20B2E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M29.0947 44.7336C34.5436 44.7336 39.9924 42.6661 44.1495 38.5326L29.0947 23.562V44.7336Z",
    fill: "#F8C92A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.0396 38.5326C18.1967 42.6676 23.6455 44.7336 29.0943 44.7336V23.562L14.0396 38.5326Z",
    fill: "#F3954E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M29.0945 23.562H7.80322C7.80322 28.9806 9.88254 34.3991 14.0397 38.5326L29.0945 23.562Z",
    fill: "#F1616F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M44.151 8.58965C39.9939 4.45467 34.545 2.38867 29.0962 2.38867V23.5603L44.151 8.58965Z",
    fill: "#397BBF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M14.0397 8.59131C9.88254 12.7263 7.80322 18.1434 7.80322 23.5619H29.0945L14.0382 8.59131H14.0397Z",
    fill: "#9A4C66"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M29.0943 2.38867C23.6455 2.38867 18.1967 4.45617 14.0396 8.58965L29.0943 23.5603V2.38867Z",
    fill: "#4254A4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M43.0874 37.3506C50.8609 29.5989 50.8609 17.031 43.0874 9.27928C35.3139 1.52759 22.7105 1.52759 14.937 9.27928C7.1635 17.031 7.1635 29.5989 14.937 37.3506C22.7105 45.1023 35.3139 45.1023 43.0874 37.3506Z",
    fill: "url(#paint1_radial_4109_656)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.2,
    d: "M28.9416 6.84842C37.7345 6.84842 45.3316 11.9064 48.9697 19.2534C47.0314 10.0215 38.8011 3.08594 28.9416 3.08594C19.0821 3.08594 10.8534 10.0215 8.91357 19.2534C12.5516 11.9064 20.1488 6.84692 28.9416 6.84692V6.84842Z",
    fill: "#010101"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M29.1156 43.4187C18.0334 43.4187 9.01855 34.4531 9.01855 23.4335C9.01855 12.4138 18.0334 3.44971 29.1156 3.44971C40.1978 3.44971 49.2127 12.4153 49.2127 23.435C49.2127 34.4546 40.1978 43.4202 29.1156 43.4202V43.4187ZM29.1156 4.59416C18.6695 4.59416 10.1692 13.0451 10.1692 23.4335C10.1692 33.8218 18.6695 42.2728 29.1156 42.2728C39.5617 42.2728 48.062 33.8218 48.062 23.4335C48.062 13.0451 39.5617 4.59416 29.1156 4.59416Z",
    fill: "#F2F2F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M26.8006 23.5743L26.6761 23.5638L9.70996 22.1426V25.006L26.6761 23.5847L26.8006 23.5743Z",
    fill: "#F2F2F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M31.4287 23.5743L31.5547 23.5847L48.5208 25.006V22.1426L31.5547 23.5638L31.4287 23.5743Z",
    fill: "#F2F2F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M29.1035 21.1489L29.114 21.2731L29.1245 21.1489L30.5542 4.27832H27.6753L29.1035 21.1489Z",
    fill: "#F2F2F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M29.1155 25.875L29.105 25.9992L27.6768 42.8697H30.5557L29.126 25.9992L29.1155 25.875Z",
    fill: "#F2F2F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M27.351 21.8208L27.27 21.7251L16.2838 8.79053L15.2742 9.79585L15.2592 9.81081L14.2495 10.8161L27.2565 21.74L27.3525 21.8208H27.351Z",
    fill: "#F2F2F2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M30.8785 25.3271L30.9595 25.4229L41.9456 38.3574L42.9553 37.3521L42.9703 37.3372L43.98 36.3318L30.973 25.4079L30.877 25.3271H30.8785Z",
    fill: "#F2F2F2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M30.8784 21.8208L30.9744 21.74L43.9814 10.8161L42.9718 9.81081L42.9568 9.79585L41.9471 8.79053L30.9609 21.7251L30.8799 21.8208H30.8784Z",
    fill: "#F2F2F2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M27.351 25.3271L27.255 25.4079L14.248 36.3318L15.2577 37.3372L15.2727 37.3521L16.2824 38.3574L27.2685 25.4229L27.3495 25.3271H27.351Z",
    fill: "#F2F2F2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M29.0945 47.123C16.029 47.123 5.3999 36.5536 5.3999 23.5622C5.3999 10.5708 16.0305 0 29.0945 0C42.1585 0 52.7891 10.5693 52.7891 23.5607C52.7891 36.5521 42.16 47.1215 29.0945 47.1215V47.123ZM29.0945 3.62036C18.0363 3.62036 9.03946 12.5665 9.03946 23.5622C9.03946 34.558 18.0363 43.5041 29.0945 43.5041C40.1527 43.5041 49.1496 34.558 49.1496 23.5622C49.1496 12.5665 40.1527 3.62036 29.0945 3.62036Z",
    fill: "#F8C92A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M28.9972 15.889L26.1152 22.7363C27.0304 22.823 28.037 22.8784 29.1247 22.8769C29.9078 22.8769 30.6474 22.8455 31.3435 22.7946C31.6916 22.7692 31.9091 22.4116 31.7756 22.0915C30.9055 20.024 30.0353 17.9565 29.1652 15.8875C29.1337 15.8142 29.0302 15.8142 29.0002 15.8875L28.9972 15.889Z",
    fill: "url(#paint2_linear_4109_656)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M29.0947 26.185C30.4674 26.185 31.5791 25.0794 31.5791 23.715C31.5791 22.3507 30.4674 21.2451 29.0947 21.2451C27.722 21.2451 26.6104 22.3507 26.6104 23.715C26.6104 25.0794 27.722 26.185 29.0947 26.185Z",
    fill: "#721011"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M31.5368 21.7699C30.9187 21.0025 30.0095 20.603 29.0929 20.603C28.4073 20.603 27.7172 20.8259 27.1411 21.2852C25.7924 22.3579 25.5734 24.3161 26.6535 25.6566C27.2716 26.424 28.1808 26.8235 29.0974 26.8235C29.783 26.8235 30.4731 26.6006 31.0492 26.1413C32.3979 25.0671 32.6169 23.1103 31.5368 21.7699ZM30.2841 25.1898C29.9435 25.4606 29.5325 25.6042 29.0974 25.6042C28.5153 25.6042 27.9737 25.3454 27.6107 24.8951C26.9551 24.0813 27.0886 22.8889 27.9077 22.2367C28.2483 21.9659 28.6593 21.8223 29.0944 21.8223C29.6765 21.8223 30.2181 22.0811 30.5811 22.5314C31.2367 23.3452 31.1032 24.5375 30.2841 25.1898Z",
    fill: "url(#paint3_linear_4109_656)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M29.948 45.4038C29.819 45.887 29.3299 46.1713 28.8573 46.0396C28.3847 45.908 28.1057 45.4098 28.2362 44.9281C28.3652 44.4449 28.8543 44.1606 29.3269 44.2923C29.7995 44.4239 30.0785 44.9206 29.948 45.4038ZM29.3269 1.10981C28.8543 0.97816 28.3652 1.2624 28.2362 1.74562C28.1072 2.22883 28.3862 2.72551 28.8573 2.85716C29.3299 2.9888 29.819 2.70456 29.948 2.22135C30.077 1.73814 29.798 1.24146 29.3269 1.10981ZM51.0442 22.7227C50.5596 22.5941 50.0586 22.8708 49.9265 23.3406C49.7945 23.8103 50.0811 24.2965 50.5656 24.4252C51.0502 24.5539 51.5513 24.2771 51.6833 23.8074C51.8153 23.3376 51.5288 22.8514 51.0442 22.7227ZM7.61857 22.7227C7.134 22.5941 6.63292 22.8708 6.5009 23.3406C6.36888 23.8103 6.65543 24.2965 7.14 24.4252C7.62458 24.5539 8.12565 24.2771 8.25767 23.8074C8.38969 23.3376 8.10315 22.8514 7.61857 22.7227ZM44.8813 9.07759C45.3163 8.82775 45.4724 8.28021 45.2323 7.85385C44.9923 7.42898 44.4432 7.28686 44.0096 7.53669C43.5746 7.78653 43.4185 8.33407 43.6586 8.76043C43.8986 9.1853 44.4477 9.32742 44.8813 9.07759ZM43.9901 38.0599C43.5626 38.2993 43.42 38.8438 43.6706 39.2761C43.9226 39.7085 44.4732 39.8641 44.9008 39.6247C45.3283 39.3854 45.4709 38.8408 45.2203 38.4085C44.9698 37.9761 44.4177 37.8205 43.9901 38.0599ZM13.2834 7.52472C12.8559 7.76409 12.7134 8.30863 12.9639 8.74098C13.2159 9.17333 13.7665 9.32892 14.1941 9.08955C14.6216 8.85019 14.7642 8.30564 14.5136 7.87329C14.2616 7.44095 13.711 7.28536 13.2834 7.52472ZM13.3029 38.0719C12.8679 38.3217 12.7119 38.8692 12.9519 39.2956C13.1919 39.7205 13.741 39.8626 14.1746 39.6128C14.6096 39.3629 14.7657 38.8154 14.5256 38.389C14.2856 37.9641 13.7365 37.822 13.3029 38.0719Z",
    fill: "#FDF7B7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4109_656",
    x1: 29.2281,
    y1: 49.3563,
    x2: 29.2281,
    y2: 46.7742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E1E1DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#949285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#252111"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4109_656",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.0119 23.3152) scale(19.9053 19.8494)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4109_656",
    x1: 26.1152,
    y1: 19.3568,
    x2: 31.8146,
    y2: 19.3568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCB316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FBAA19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FBAD18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FEBB1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FED940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FEEB5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FEF275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FEF275"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4109_656",
    x1: 25.9664,
    y1: 23.7132,
    x2: 32.2224,
    y2: 23.7132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCB316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FBAA19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FBAD18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FEBB1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FED940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FEEB5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FEF275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FEF275"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpin);
export default __webpack_public_path__ + "static/media/icon_spin.f2b883d4038a30898d9da198d39d510d.svg";
export { ForwardRef as ReactComponent };